<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row mb-2 pt-3">
        <div class="col-sm-6">
          <h1>Panel de Reportes</h1>
        </div>
      </div>

      <!-- Filtros de Reporte -->
      <div class="card card-default">
        <div class="card-header">
          <h3 id="config-reporte" class="card-title">Configuración del Reporte</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Tipo de Reporte</label>
                <select id="select-tipo" class="form-control" v-model="filtros.tipo">
                  <option value="ventas">Ventas Finalizadas</option>
                  <option value="pedidos">Pedidos</option>
                  <option value="movimientos">Movimientos de Inventario</option>
                  <option value="clientes">Listado de Clientes</option>
                  <option value="creditos">Cuentas por Cobrar (Créditos)</option>
                  <option value="pagos">Relación de Pagos</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Desde</label>
                <input id="input-desde" type="date" class="form-control focus-input" v-model="filtros.desde">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Hasta</label>
                <input id="input-hasta" type="date" class="form-control focus-input" v-model="filtros.hasta">
              </div>
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <div class="w-100">
                <button id="btn-generar" @click="generarReporte" class="btn btn-primary btn-block mb-2"
                  :disabled="loading">
                  <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                  <i v-else class="fas fa-file-pdf"></i> PDF
                </button>
                <button @click="generarExcel" class="btn btn-success btn-block mb-2" :disabled="loadingExcel">
                  <i v-if="loadingExcel" class="fas fa-spinner fa-spin"></i>
                  <i v-else class="fas fa-file-excel"></i> Excel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Resumen Visual (Opcional) -->
      <div class="row">
        <div class="col-lg-3 col-6">
          <div class="small-box bg-info">
            <div class="inner">
              <h3>Reportes</h3>
              <p>Ventas y Cobranzas</p>
            </div>
            <div class="icon">
              <i class="fas fa-chart-line"></i>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-6">
          <div class="small-box bg-success">
            <div class="inner">
              <h3>Inventario</h3>
              <p>Movimientos de Stock</p>
            </div>
            <div class="icon">
              <i class="fas fa-boxes"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue';
import api from '@/services/api';
import { tutorial } from "@/plugins/tutorial";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
  name: 'ReportesView',
  data() {
    return {
      loading: false,
      loadingExcel: false,
      filtros: {
        tipo: 'ventas',
        desde: new Date().toISOString().substr(0, 10),
        hasta: new Date().toISOString().substr(0, 10)
      }
    };
  },
  setup() {
    function iniciarTutorial() {
      const steps = [
        {
          element: '#select-tipo',
          title: 'Tipo de Reporte',
          text: 'Primero, selecciona qué tipo de información deseas obtener (Ventas, Inventario, Clientes, etc.).',
          position: 'bottom'
        },
        {
          element: '#input-desde',
          title: 'Fecha Inicial',
          text: 'Indica la fecha de inicio para el filtrado de los datos.',
          position: 'bottom'
        },
        {
          element: '#input-hasta',
          title: 'Fecha Final',
          text: 'Indica la fecha de corte para los parámetros del reporte.',
          position: 'bottom'
        },
        {
          element: '#btn-generar',
          title: 'Generar PDF',
          text: 'Haz clic aquí para procesar y descargar tu reporte en formato PDF.',
          position: 'left'
        }
      ];
      tutorial.start(steps);
    }

    onMounted(() => {
      tutorial.set(iniciarTutorial);
    });

    onBeforeUnmount(() => {
      tutorial.set(null);
    });
  },
  methods: {
    async generarReporte() {
      this.loading = true;
      loading.show('Generando reporte...');
      try {
        const response = await api.get(`/pdf/reporte/${this.filtros.tipo}/${this.filtros.desde}/${this.filtros.hasta}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Reporte_${this.filtros.tipo}_${this.filtros.desde}_al_${this.filtros.hasta}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        loading.hide();

        this.$toast({ icon: 'success', title: 'Reporte generado correctamente' });
      } catch (error) {
        console.error('Error al generar reporte:', error);
        loading.hide();
        alert.show({
          title: 'Error',
          text: 'No se pudo generar el reporte. Verifique los datos e intente de nuevo.',
          icon: 'error'
        });
      } finally {
        this.loading = false;
      }
    },
    async generarExcel() {
      this.loadingExcel = true;
      loading.show('Generando Excel...');
      try {
        const url = `/excel/reporte/${this.filtros.tipo}/${this.filtros.desde}/${this.filtros.hasta}`;

        const response = await api.get(url, { responseType: 'blob' });

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `Reporte_${this.filtros.tipo}_${this.filtros.desde}_al_${this.filtros.hasta}.xls`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        loading.hide();

        this.$toast({ icon: 'success', title: 'Excel generado correctamente' });
      } catch (error) {
        console.error('Error al generar Excel:', error);
        loading.hide();
        alert.show({
          title: 'Error',
          text: 'No se pudo generar el archivo Excel.',
          icon: 'error'
        });
      } finally {
        this.loadingExcel = false;
      }
    }
  }
};
</script>

<style scoped>
.small-box {
  border-radius: 0.25rem;
  position: relative;
  display: block;
  margin-bottom: 20px;
  box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
}

.focus-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
